import type {
  Direction,
  LogicalAlignment,
  WithInherit,
} from '@wix/editor-elements-common-utils';
import {
  castFromInheritIfNeeded,
  getOppositeAlign,
} from '@wix/editor-elements-common-utils';

export const reverseAlignmentOnRtl = (
  alignment: LogicalAlignment,
  direction: WithInherit<Direction>,
  parentDirection: Direction,
) =>
  alignment !== 'center' &&
  castFromInheritIfNeeded(direction, parentDirection) === 'rtl'
    ? getOppositeAlign(alignment)
    : alignment;
